// Brand philosophy — short centered declaration, lots of whitespace.

import { motion } from "framer-motion";
import { useLocale } from "@/lib/i18n";

export function BrandPhilosophy() {
  const locale = useLocale();

  const lines =
    locale === "da"
      ? ["Vi køber ikke lager.", "Vi vælger stykker, vi selv ville sætte hjemme."]
      : ["We don't buy inventory.", "We pick pieces we'd put in our own home."];

  return (
    <section className="relative mx-auto max-w-[1500px] px-6 py-20 md:px-10 md:py-52">
      <div className="mx-auto max-w-3xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="space-y-5"
        >
          {lines.map((l, i) => (
            <p
              key={l}
              className={`font-display text-[clamp(1.6rem,3.4vw,2.6rem)] leading-[1.2] ${
                i === 1 ? "display-italic text-terracotta" : "text-foreground"
              }`}
            >
              {l}
            </p>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
